import React, { useCallback, useEffect } from 'react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useValidation } from 'gw-portals-validation-react';
import _ from 'lodash';
import { CepConstants } from 'saga-cep-specific-components';
import { useSgTrackPageName } from 'saga-modules';
import metadata from './SgVehicleRegistrationForm.metadata.json5';

function SgVehicleRegistrationForm(props) {
    const {
        id,
        modelVM,
        updateData,
        showErrors,
        onValidate: onValidateParent
    } = props;

    const {
        onValidate,
        isComponentValid,
    } = useValidation(id);

    useSgTrackPageName(CepConstants.PAGE_NAMES.VEHICLE_CHANGES_REGISTRATION);

    useEffect(() => {
        return () => {
            if (onValidateParent) {
                // workaround when component was not valid but is no longer needed (hidden)
                onValidateParent(true, id);
            }
        };
    }, []);

    useEffect(() => {
        if (onValidateParent) {
            onValidateParent(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidateParent]);

    const setRegToUpperCase = useCallback((value, path) => {
        const copyModel = _.clone(modelVM);
        if (value === '') {
            _.set(copyModel, path, undefined);
        } else {
            _.set(copyModel, path, value.replace(' ', '').toUpperCase());
        }
        updateData(copyModel);
    }, [modelVM, updateData]);

    const overrides = {
        regNumber: {
            path: 'lobData.privateMotor.coverables.spmVehicle.registrationNumber',
            onValueChange: setRegToUpperCase
        }
    };
    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {}
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={modelVM}
            onModelChange={updateData}
            overrideProps={overrides}
            showErrors={showErrors}
            onValidationChange={onValidate}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default SgVehicleRegistrationForm;
